import { registerSW } from 'virtual:pwa-register';

export function registerServiceWorker(onNeedRefresh: (applyUpdate: () => Promise<void>) => void) {
    if (import.meta.env.DEV) return;

    const updateSW = registerSW({
        immediate: true,
        onNeedRefresh() {
            console.info('[PWA] Nuova versione disponibile');
            onNeedRefresh(() => updateSW(true));
        },
        onOfflineReady() {
            console.info('[PWA] App pronta per l\'uso offline');
        },
        onRegisteredSW(swUrl) {
            console.info('[PWA] Service worker registrato:', swUrl);
        },
        onRegisterError(error) {
            console.error('[PWA] Registrazione service worker fallita:', error);
        },
    });
}
